// Never let an original or rights document become a public preview, even when
// a caller supplies a private asset view (e.g. while switching workspaces).
export function digitalPreviews<T extends { kind: string; mime: string }>(
  files: T[],
  category: string,
): T[] {
  const preferred = category === 'audio' ? 'audio/' : category === 'video' ? 'video/' : 'image/';
  return files
    .filter((file) => file.kind === 'preview')
    .sort((a, b) => Number(b.mime.startsWith(preferred)) - Number(a.mime.startsWith(preferred)));
}
export function digitalPreviewLabel(mime: string) {
  return mime.startsWith('video/') ? '视频' : mime.startsWith('audio/') ? '试听' : '图片';
}
